import { render } from "./QuestionForm.vue?vue&type=template&id=2783c315&scoped=true"
import script from "./QuestionForm.vue?vue&type=script&lang=ts"
export * from "./QuestionForm.vue?vue&type=script&lang=ts"

import "./QuestionForm.vue?vue&type=style&index=0&id=2783c315&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2783c315"

export default script